import OrderDelete from './OrderDelete'
export {OrderDelete}
export default OrderDelete
